import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class RequestService {
  public async handleRequest<T>(request: Promise<T>): Promise<T> {
    try {
      return await request;
    } catch (error: any) {
      throw new Error(error?.message || 'Error desconocido en la API');
    }
  }
}
